module.exports = __webpack_public_path__ + "static/media/LPZ.4b0d604f.jpg";